import React from 'react';
import {connect} from 'react-redux'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, PointElement, LineElement } from 'chart.js'
import { Chart } from 'react-chartjs-2';
import validate from 'validate.js';

import * as actions from './store/actions'

import { chartjs } from './helpers';
import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import validators from './common/validators';
import Routes from './Router';
import Toasts from './components/UI/Toasts'
// import { ThemeProvider } from '@mui/material/styles';
// import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider } from '@emotion/react';

// import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

    ChartJS.register(
      CategoryScale,
      LinearScale,
      BarElement,
      Title,
      Tooltip,
      Legend,
      ArcElement,
      PointElement,
      LineElement
    );


// Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
//   draw: chartjs.draw
// });

validate.validators = {
  ...validate.validators,
  ...validators
};

const App = props => {
  const { 
    onAutoLogin,
    token
  } = props

  // useEffect(() => {
  //   const local_storage_token = localStorage.getItem("token")
  //   const redirect = props.location.path
  //   if((local_storage_token && !token) || (local_storage_token && token && (local_storage_token !== token))){
  //     onAutoLogin(local_storage_token, redirect)
  //   }
  // }, [onAutoLogin, token])

  return (
    // <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <Routes />
        <Toasts />
      </ThemeProvider>
    // </MuiThemeProvider>
    // <ThemeProvider theme={theme}>
    //   <Routes />
    //   <Toasts />
    // </ThemeProvider>
  );
}

const mapStateToProps = state => {
  return {
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onAutoLogin: (token, redirect) => dispatch(actions.autoLogin(token, redirect))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
